// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EKJo","fullView":"styles_fullView__2Qwa4"};